<template>
  <div class="reservar-page">
    <v-card>
      <v-card-title
        ><span class="headline">{{
          $t("home.reserva.title")
        }}</span></v-card-title
      >
      <div class="center">
        <div
          class="discount"
          v-if="storeInfo.storeConf && storeInfo.storeConf.openReservDiscount"
        >
          <div class="num">
            {{$t("order.discount")}} &nbsp;&nbsp;&nbsp;&nbsp;
            <span
              v-if="
                storeInfo.storeConf.reservDiscount &&
                  Number(storeInfo.storeConf.reservDiscount)
              "
            >
              -{{ storeInfo.storeConf.reservDiscount || 0 }}%
            </span>
          </div>
        </div>
      </div>
      <v-card-text>
        <v-form>
          <v-container>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  :label="$t('home.reserva.name')"
                  required
                  v-model="name"
                  :rules="nameRules"
                  ref="name"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :label="$t('home.reserva.email')"
                  required
                  v-model="email"
                  :rules="emailRules"
                  ref="email"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :label="$t('home.reserva.phone')"
                  required
                  v-model="phone"
                  :rules="phoneRules"
                  ref="phone"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-dialog
                  ref="dateDialog"
                  v-model="datePickerVisible"
                  persistent
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      readonly
                      :label="$t('home.reserva.date')"
                      v-on="on"
                      v-model="date"
                      ref="date"
                      :rules="dateRules"
                      :return-value.sync="dateFormat"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    scrollable
                    v-model="date"
                    :first-day-of-week="1"
                    :allowed-dates="disableDateFunc"
                    locale="es-es"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      color="primary"
                      @click="datePickerVisible = false"
                    >
                      {{ $t("home.reserva.cancel") }}
                    </v-btn>
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.dateDialog.save(date)"
                    >
                      {{ $t("home.reserva.confirm") }}
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs4 style="display: flex;">
                <date-picker
                  v-model="time"
                  format="HH:mm"
                  type="time"
                  :disabled="!date"
                  :disabled-time="disableTimeFunc"
                  :placeholder="$t('home.reserva.time')"
                ></date-picker>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  :label="$t('home.reserva.number')"
                  :rules="numberRules"
                  required
                  v-model="number"
                  ref="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  auto-grow
                  :label="$t('home.reserva.remark')"
                  :rules="remarkRules"
                  rows="1"
                  v-model="remark"
                  ref="remark"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <router-link :to="{ name: 'home' }">
          <v-btn color="primary" flat>
            {{ $t("home.reserva.close") }}
          </v-btn>
        </router-link>
        <v-btn
          color="primary"
          flat
          @click="reservaSubmit()"
          :loading="submitIng"
        >
          {{ $t("home.reserva.order") }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="reservaSuccessVisible" width="70%">
      <v-card>
        <!--            <v-card-title>-->
        <!--                <span class="headline">-->
        <!--                  {{ $t("home.reserva.success") }}-->
        <!--                </span>-->
        <!--            </v-card-title>-->
        <img
          src="./../../assets/reserve_success.png"
          style="display: block;width: 100%;max-width: 600px;margin: 0 auto;"
          alt=""
        />
        <div
          class="text"
          style="text-align: center; padding: 0 15px;font-size: 28px;color: rgba(251, 116, 46, 1);line-height: 40px;"
        >
          {{ $t("home.reserva.reverse") }}
        </div>
        <v-card-actions style="justify-content: center;">
          <!--                <v-spacer></v-spacer>-->
          <v-btn
            color="primary"
            flat
            @click="gotoIndex"
            style="margin: 20px 0;background-color: #F9AE05;color: #FFF!important;"
          >
            {{ $t("home.reserva.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import order from "@/api/order";
import "vue2-datepicker/index.css";
import Order from "./../../api/order";

export default {
  name: "reservar",
  components: {
    DatePicker
  },
  data() {
    return {
      submitIng: false, //提交中
      datePickerVisible: false,
      reservaSuccessVisible: false,
      dateFormat: new Date().toISOString().substr(0, 10),
      name: "",
      nameRules: [value => !!value || this.$t("home.reserva.nameRequired")],
      email: "",
      emailRules: [
        value => !!value || this.$t("home.reserva.emailRequired"),
        value =>
          /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/.test(
            value
          ) || this.$t("common.email_rule")
      ],
      phone: "",
      phoneRules: [value => !!value || this.$t("home.reserva.phoneRequired")],
      date: "",
      dateRules: [value => !!value || this.$t("home.reserva.dateRequired")],
      time: "",
      number: 2,
      numberRules: [
        value => !!value || this.$t("home.reserva.numberRequired"),
        value =>
          /^[1-9][0-9]*$/.test(value) || this.$t("home.reserva.numberFormat")
      ],
      remark: "",
      remarkRules: [value => !!value || this.$t("home.reserva.remarkRequired")],
      businessHours: null,
      businessHoursKey: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"]
    };
  },
  created() {
    this.getBusinessHours();
    if (this.userInfo) {
      this.name = this.userInfo.name;
      this.phone = this.userInfo.phone;
      this.email = this.userInfo.email;
    }
  },
  computed: {
    ...mapState(["storeInfo", "userInfo", "isLogin", "storeId", "storeInfo"]),
    reservaForm() {
      return {
        name: this.name,
        phone: this.phone,
        email: this.email,
        date: this.date,
        time: this.time ? moment(this.time).format("HH:mm") + ":00" : "",
        number: parseInt(this.number),
        remark: this.remark,
        customer_guid: this.userInfo && this.userInfo.guid
      };
    }
  },
  methods: {
    reservaSubmit() {
      if (this.submitIng) return;
      let isFull = true;
      Object.keys(this.reservaForm).forEach(f => {
        if (f === "time") return;
        if (f === "customer_guid") return;
        if (!this.reservaForm[f]) {
          this.formHasErrors = true;
          this.$refs[f].validate(true);
          isFull = false;
        }
      });

      if (isFull) {
        this.createReserva();
      }
    },
    async createReserva() {
      try {
        if (!this.reservaForm.time) {
          alert("Se requiere tiempo");
          return;
        }
        this.submitIng = true;
        const res = await order.createReserva(this.reservaForm);
        this.submitIng = false;

        if (!res.data.isError) {
          this.reservaSuccessVisible = true;
        }
      } catch (e) {
        console.log(e);
      }
    },
    gotoIndex() {
      this.reservaSuccessVisible = false;
      this.$router.push({
        name: "home"
      });
    },
    async getBusinessHours() {
      let {
        data: { isError, data }
      } = await Order.getBusinessHours();
      if (!isError) {
        this.businessHours = data || {};
      }
    },
    disableDateFunc(date) {
      let week = new Date(date).getDay() || 7;
      let key = this.businessHoursKey[week - 1];
      return this.businessHours && this.businessHours[key];
    },
    disableTimeFunc(time) {
      let week = new Date(this.date).getDay() || 7;
      let key = this.businessHoursKey[week - 1];
      let setting = (this.businessHours && this.businessHours[key]) || [];
      let flag = true;
      setting.forEach(item => {
        let startTime = (item.startTime || "").replace(/:/g, "");
        let endTime = (item.endTime || "").replace(/:/g, "");
        let current = `${time.getHours()}${addZero(time.getMinutes())}`;
        if (Number(current) >= startTime && Number(current) <= endTime) {
          flag = false;
        }
      });
      return flag;
    }
  }
};

function addZero(num) {
  return num < 10 ? `0${num}` : num;
}
</script>

<style lang="sass" src="./reservar.sass"></style>
